import { replace } from "lodash-es";
import checkHolidays from "./checkHolidays";
import customCloseDaysUpdateTable from "./customCloseDaysUpdateTable";

export function tableHours() {
    if(document.querySelector('.js-table-hours')){
      
      const tablesNodelist = document.querySelectorAll('.js-table-hours')
		const date = new Date();
		const dayNumber = date.getDay();
      let counter = 0;
      const holidays = checkHolidays(date)

      //function that returns true or false to whether current day is within the custom closing period. Takes two dates as argument in format YYYY-MM-DD
      function checkCustomCloseDays(start, end){
        let startDay = new Date(`${start}T00:00:01`)
        let endDay = new Date(`${end}T23:59:59`)
        let today = new Date();
        let startTimestamp = startDay.getTime()
        let endTimestamp = endDay.getTime()
        let currentTimestamp = today.getTime()
        if (currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp){ return true
        } else { return false }
      }

      function startOfDay(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
      }
      function endOfDay(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
      }

      function getLocale() {
        const raw = document.documentElement.lang || 'da';
        return raw.toLowerCase().startsWith('en') ? 'en-US' : raw;
      }

      function formatLocalDate(date) {
        return new Intl.DateTimeFormat(getLocale(), { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
      }

      function localWeekdayName(date) {
        return new Intl.DateTimeFormat(getLocale(), { weekday: 'long' }).format(date);
      }

      function readI18n(table) {
        const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
        const en = { opensAt: 'Opens at', opensOn: 'Opens', holiday: 'Holiday', closesAt: 'Closes at', busyUntil: 'Busy until' };
        const da = { opensAt: 'Åbner kl.', opensOn: 'Åbner', holiday: 'Helligdag', closesAt: 'Lukker kl.', busyUntil: 'Travlt indtil kl.' };
        const i18n = isEnglish ? { ...en } : {
          opensAt: table.getAttribute('data-i18n-opens-at') || da.opensAt,
          opensOn: table.getAttribute('data-i18n-opens-on') || da.opensOn,
          holiday: table.getAttribute('data-i18n-holiday') || da.holiday,
          closesAt: table.getAttribute('data-i18n-closes-at') || da.closesAt,
          busyUntil: table.getAttribute('data-i18n-busy-until') || da.busyUntil
        };
        // Derive the time preposition ("kl." / "at") by stripping the verb prefix
        i18n.atPrefix = i18n.opensAt.replace(new RegExp('^' + i18n.opensOn.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*', 'i'), '').trim();
        return i18n;
      }

      function parseYmd(ymd) {
        // ymd like "2026-01-09"
        const [y, m, d] = ymd.split("-").map(Number);
        return new Date(y, m - 1, d);
      }

      function isInClosedPeriod(date, startYmd, endYmd) {
        if (!startYmd) return false;
        const start = startOfDay(parseYmd(startYmd));
        const end = endYmd ? endOfDay(parseYmd(endYmd)) : endOfDay(parseYmd(startYmd));
        const t = date.getTime();
        return t >= start.getTime() && t <= end.getTime();
      }

      //function that sets the strings for custom closed days
      function customCloseDays(day, start, end, indicator){
        let endDate = new Date(end);
        let startDate = new Date(start);

        let endDateFormatted = formatLocalDate(endDate);
        let startDateFormatted = formatLocalDate(startDate);

        //hides normal status message and displays closed status message
        day.parentNode.querySelector('.status').classList.add('hidden')
        indicator.classList.remove('hidden')

        day.parentElement.querySelector('.js-close-start').textContent = startDateFormatted
        day.parentElement.querySelector('.js-close-end').textContent = endDateFormatted

        //check if only closed on one day
        if(start == end || !end){
          let spans = day.parentElement.querySelector('.js-info-close-dates').children
          spans[3].classList.add('hidden')
          spans[4].classList.add('hidden')
          day.parentElement.querySelector('.js-close-start').textContent = startDateFormatted
        }
      }

      function FindNextOpenDay(day, dayNumber, closedStartYmd, closedEndYmd) {
        let i = dayNumber;
        let counter = 0;

        const probe = startOfDay(new Date());
        probe.setDate(probe.getDate() + 1);
        i = (i + 1) % 7;

        while (counter < 30) {
          const isHoliday = checkHolidays(probe).isHoliday;
          const isClosedByPeriod = isInClosedPeriod(probe, closedStartYmd, closedEndYmd);

          // ✅ Only trust the current table's inactive-days within the displayed week
          let isInactiveInTable = false;
          if (counter < 7) {
            const row = day.parentNode.parentNode.querySelector(`.js-day-${i}`)?.parentNode;
            isInactiveInTable = row ? row.classList.contains('inactive') : false;
          }

          if (!isHoliday && !isClosedByPeriod && !isInactiveInTable) {
            const nextOpenDayEl = day.parentNode.parentNode.querySelector(`.js-day-${i}`);
            const openTime = nextOpenDayEl?.parentNode.querySelector('.open')?.textContent ?? '';
            const nextDate = new Date(probe);

            return { date: nextDate, weekdayName: localWeekdayName(nextDate), openTime, daysAway: counter + 1 };
          }

          probe.setDate(probe.getDate() + 1);
          i = (i + 1) % 7;
          counter++;
        }

        return false;
      }



      // An array of each table with opening hours (corresponds to each week-overview/card)

      let tables = Array.prototype.slice.call(tablesNodelist,0)
      //loop over each table
      tables.forEach(table => {
        let tableDays = table.querySelectorAll('.day')
        let disableHolidays = table.classList.contains('js-disable-holidays');
        const i18n = readI18n(table);

        //check if there are specific holiday opening hours
        let holidayHours = table.getAttribute('data-holiday-hours') && table.getAttribute('data-holiday-hours') != "," ? table.getAttribute('data-holiday-hours') : false;
        let holidayHoursAlt = table.getAttribute('data-holiday-hours-alt') && table.getAttribute('data-holiday-hours-alt') != "," ? table.getAttribute('data-holiday-hours-alt') : false;
        let holidayHoursBusy = table.getAttribute('data-holiday-busy') && table.getAttribute('data-holiday-busy') != "," ? table.getAttribute('data-holiday-busy') : false;

        //update table if there are holidays in the week (and day is not otherwise a closed day)
        if(holidays.holidaysInCurrentWeek.includes(true) && !disableHolidays){
          holidays.holidaysInCurrentWeek.forEach((item, index) => {
            //if there is a holiday, but there are holiday hours, set the holiday hours
            if(holidayHours && item && tableDays[index].parentNode.classList.contains('active')){
              tableDays[index].parentElement.querySelector('td').innerHTML = `
              <span class="open">${holidayHours.split(',')[0].replace(':','.')}</span>
              <span>–</span>
              <span class="close">${holidayHours.split(',')[1].replace(':','.')}</span>`
              if(holidayHoursAlt){
                tableDays[index].parentElement.querySelector('td').innerHTML += `
                <span class="card__hours--divider">/</span>
                <span class="openTwo">${holidayHoursAlt.split(',')[0].replace(':','.')}</span>
                <span>–</span>
                <span class="closeTwo">${holidayHoursAlt.split(',')[1].replace(':','.')}</span>
                `
              }
              if(holidayHoursBusy){
                tableDays[index].parentElement.querySelector('td').innerHTML += `
                <span class="js-busy-start hidden">${holidayHoursBusy.split(',')[0].replace(':','.')}</span>
                <span class="js-busy-end hidden">${holidayHoursBusy.split(',')[1].replace(':','.')}</span>
                `
              }
            } else if(item && tableDays[index].parentNode.classList.contains('active')){
              tableDays[index].parentElement.classList.add('inactive')
              tableDays[index].parentElement.classList.remove('active')
              tableDays[index].parentElement.querySelector('td').textContent = i18n.holiday
            }
          })
        }


        //update table view if there are custom closed days
        if(table.parentNode.querySelector('.js-info-close-dates')){
          customCloseDaysUpdateTable(table)
        }
        
        //find which day is current day and set status message depending on time and parameters
        tableDays.forEach(day => {

          if(day.classList.contains(`js-day-${dayNumber}`) && table.parentNode.querySelector('.status')){
            //Time variables
            let currentDayOpenTime = day.parentNode.querySelector('.open') ? parseFloat(day.parentNode.querySelector('.open').textContent.replace(":", ".")) : false;
            let currentDayClosingTime = day.parentNode.querySelector('.close') ? parseFloat(day.parentNode.querySelector('.close').textContent.replace(":", ".")) : false;
            let currentDayOpenTimeTwo = day.parentNode.querySelector('.openTwo') ? parseFloat(day.parentNode.querySelector('.openTwo').textContent.replace(":", ".")) : false;
            let currentDayClosingTimeTwo = day.parentNode.querySelector('.closeTwo') ? parseFloat(day.parentNode.querySelector('.closeTwo').textContent.replace(":", ".")) : false;
            let busyTimeStart = day.parentNode.querySelector('.js-busy-start')? parseFloat(day.parentNode.querySelector('.js-busy-start').textContent.replace(":", ".")) : false;
            let busyTimeEnd = day.parentNode.querySelector('.js-busy-end') ? parseFloat(day.parentNode.querySelector('.js-busy-end').textContent.replace(":", ".")) : false;
            let currentTime = parseFloat(`${date.getHours()}.${date.getMinutes()}`)

            //Element variables
            let statusIndicatorElement = table.parentNode.querySelector('.status-indicator')
            let statusTextElement = table.parentNode.querySelector('.status-text')
            let statusClosedElement = table.parentNode.querySelector('.status-indicator-closed')
            let statusOpenElement = table.parentNode.querySelector('.status-indicator-open')
            //let busyTimeEndElement = table.parentNode.querySelector('.js-busy-end')

            //Custom closed day variables
            let closedDayIndicator = table.parentElement.querySelector('.js-info-close-dates') ? table.parentElement.querySelector('.js-info-close-dates') : false;
            let closedDayStart = table.parentElement.querySelector('.js-close-start') ? table.parentElement.querySelector('.js-close-start').textContent : false
            let closedDayEnd = table.parentElement.querySelector('.js-close-end') ? table.parentElement.querySelector('.js-close-end').textContent : false

            //Formatted start date
            let startDate = new Date(closedDayStart);
            let startDateFormatted = formatLocalDate(startDate)

            //check if custom closed day
            if(closedDayStart && checkCustomCloseDays(closedDayStart, closedDayEnd)){
              customCloseDays(table, closedDayStart, closedDayEnd, closedDayIndicator)
            }

            //check if closed today
            else if(day.parentNode.classList[0].includes('inactive')){

              if(FindNextOpenDay(day, dayNumber, closedDayStart, closedDayEnd)){
                const next = FindNextOpenDay(day, dayNumber, closedDayStart, closedDayEnd);

                if (next) {
                  const useDate = next.daysAway > 7;
                  const timePart = next.openTime ? ` ${i18n.atPrefix} ${next.openTime}` : '';
                  const label = useDate ? formatLocalDate(next.date) : next.weekdayName;

                  statusTextElement.textContent = `${i18n.opensOn} ${label}${timePart}`;
                  statusTextElement.classList.remove('hidden');
                } else {
                  statusTextElement.textContent = startDateFormatted;
                }

                statusTextElement.classList.remove('hidden')
              } else {
                statusTextElement.textContent = startDateFormatted
              }
              statusIndicatorElement && statusIndicatorElement.classList.add('closed-fill')
              statusOpenElement && statusOpenElement.classList.add('hidden')
              if(FindNextOpenDay(day, dayNumber, closedDayStart, closedDayEnd) == " "){
                statusTextElement.classList.add('hidden')
              }
            }

            //check if holiday
            else if (holidays.isHoliday && !disableHolidays && !holidayHours) {
              statusIndicatorElement && statusIndicatorElement.classList.add('closed-fill');
              statusOpenElement && statusOpenElement.classList.add('hidden');

              const next = FindNextOpenDay(day, dayNumber, closedDayStart, closedDayEnd);

              if (next) {
                const useDate = next.daysAway > 7;
                const timePart = next.openTime ? ` ${i18n.atPrefix} ${next.openTime}` : '';
                const label = useDate ? formatLocalDate(next.date) : next.weekdayName;
                statusTextElement.textContent = `${i18n.holiday}. ${i18n.opensOn} ${label}${timePart}`;

                statusTextElement.classList.remove('hidden');
              } else {
                statusTextElement.textContent = startDateFormatted;
              }
            }

            //check if open (current time is within opening hours)
            else if(currentDayOpenTime && (currentTime >= currentDayOpenTime && currentTime < currentDayClosingTime)){
              
              //check if within busy time
              if(busyTimeStart && (currentTime >= busyTimeStart && currentTime < busyTimeEnd)){
                statusIndicatorElement && statusIndicatorElement.classList.add('busy-fill')
                statusClosedElement && statusClosedElement.classList.add('hidden')
                statusOpenElement && statusOpenElement.classList.add('busy')
                statusOpenElement && statusOpenElement.classList.remove('opened')
                statusTextElement.textContent = `${i18n.busyUntil} ${busyTimeEnd}`
              } else {
                //if open and outside busy time
                statusIndicatorElement && statusIndicatorElement.classList.add('open-fill')
                statusClosedElement && statusClosedElement.classList.add('hidden')
                statusTextElement.textContent = `${i18n.closesAt} ${day.parentNode.querySelector('.close').textContent}`
              }
            }

            //check if open in second open period (current time is within second opening hours)
            else if(currentDayOpenTimeTwo && (currentTime >= currentDayOpenTimeTwo && currentTime < currentDayClosingTimeTwo)){
              //check if within busy time
              if(busyTimeStart && (currentTime >= busyTimeStart && currentTime < busyTimeEnd)){
                statusIndicatorElement && statusIndicatorElement.classList.add('busy-fill')
                statusClosedElement && statusClosedElement.classList.add('hidden')
                statusOpenElement && statusOpenElement.classList.add('busy')
                statusOpenElement && statusOpenElement.classList.remove('opened')
                statusTextElement.textContent = `${i18n.busyUntil} ${busyTimeEnd}`
              } else {
                //if open and outside busy time
                statusIndicatorElement && statusIndicatorElement.classList.add('open-fill')
                statusClosedElement && statusClosedElement.classList.add('hidden')
                statusTextElement.textContent = `${i18n.closesAt} ${day.parentNode.querySelector('.closeTwo').textContent}`
              }
            }


            //check if before opening hours (opens later today)
            else if (currentDayOpenTime && (currentTime < currentDayOpenTime)) {
              statusIndicatorElement && statusIndicatorElement.classList.add('closed-fill')
              statusOpenElement && statusOpenElement.classList.add('hidden')
              statusTextElement.textContent = `${i18n.opensAt} ${day.parentNode.querySelector('.open').textContent}`
            }
            //check if between opening hours (opens again later today)
            else if (currentDayOpenTimeTwo && (currentTime < currentDayOpenTimeTwo)) {
              statusIndicatorElement && statusIndicatorElement.classList.add('closed-fill')
              statusOpenElement && statusOpenElement.classList.add('hidden')
              statusTextElement.textContent = `${i18n.opensAt} ${day.parentNode.querySelector('.openTwo').textContent}`
            }
            //else, closed
            else {
              statusIndicatorElement && statusIndicatorElement.classList.add('closed-fill')
              if(FindNextOpenDay(day, dayNumber, closedDayStart, closedDayEnd)){
                const next = FindNextOpenDay(day, dayNumber, closedDayStart, closedDayEnd);
                if (next) {
                  const useDate = next.daysAway > 7;
                  const timePart = next.openTime ? ` ${i18n.atPrefix} ${next.openTime}` : '';
                  const label = useDate ? formatLocalDate(next.date) : next.weekdayName;

                  statusTextElement.textContent = `${i18n.opensOn} ${label}${timePart}`;
                  statusTextElement.classList.remove('hidden');
                } else {
                  statusTextElement.textContent = startDateFormatted;
                }
              } else {
                statusTextElement.textContent = startDateFormatted
              }
              statusOpenElement && statusOpenElement.classList.add('hidden')
            }
          }
        })
      })
    }
}

export default tableHours;
